import * as React from 'react';

import loggerSingleton from 'js/app/loggerSingleton';
import { useLocation, useNavigate } from 'js/lib/useRouter';
import { isAuthenticatedUser } from 'js/lib/user';

import CourseraPlusProductVariants from 'bundles/coursera-plus/constants/CourseraPlusProductVariant';
import { SUBSCRIBE_TO_COURSERA_PLUS } from 'bundles/enroll-course/common/EnrollmentChoiceTypes';
import {
  choiceTypeToHandleSubmitPromise,
  submitEnrollmentPromise,
} from 'bundles/enroll-course/lib/enrollmentChoiceUtils';

export const useEnrollInOrUpgradeToCourseraPlus = () => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = React.useState(false);

  const handleEnrollInCourseraPlus = () => {
    if (!isAuthenticatedUser()) {
      navigate(`${location.pathname}?authMode=signup&action=enroll`);
      return;
    }

    const handleSubmitPromise = choiceTypeToHandleSubmitPromise[SUBSCRIBE_TO_COURSERA_PLUS];
    const options = {
      isSubscriptionOnly: true,
      productItemId: CourseraPlusProductVariants.MONTHLY_WITH_FREE_TRIAL,
    };
    setIsSubmitting(true);
    submitEnrollmentPromise({ handleSubmitPromise, options }).catch((apiError) => {
      loggerSingleton.error(`Failed to checkout Coursera Plus: ${apiError}`);
      setError(true);
      setIsSubmitting(false);
    });
  };

  return {
    isSubmitting,
    error,
    handleEnrollInCourseraPlus,
  };
};
